module.exports = __webpack_public_path__ + "static/media/cc.4c26158a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/cc.svg
// module id = 70
// module chunks = 0